// Tiny localStorage helpers. Three callers (`demo-store`, `rejected`,
// `last-spin`) were each carrying their own try/catch JSON wrappers, same
// shape, same "ignore quota / private mode" branch. Centralised here so
// the storage-failure policy lives in one place.

export function readJson<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return fallback;
    return JSON.parse(raw) as T;
  } catch {
    return fallback;
  }
}

export function writeJson(key: string, value: unknown): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    /* quota / private mode → ignore */
  }
}
